module.exports = __webpack_public_path__ + "static/media/main idea.f44e7f64.mp3";